module.exports = "/assets/js/b776b5fc50eb3111941807ea4136b9ec.svg";